import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';

const formatOutcome = (outcome: string): string => {
  const outcomeMap: Record<string, string> = {
    TRANSFERRED_TO_FLOW: 'Transfer to Flow',
    TRANSFERRED_TO_AGENT: 'Transfer to Agent',
    TRANSFERRED_TO_PHONE_NUMBER: 'Transfer to Phone Number',
    DROPPED: 'Dropped',
    DISCONNECTED_PARTICIPANT: 'Disconnected Participant',
    ENDED_FLOW_EXECUTION: 'Flow Ended'
  };

  return outcomeMap[outcome] || outcome;
};

const getOutcomeColor = (
  outcome: string
): {
  backgroundColor: string;
  color: string;
  borderColor: string;
} => {
  switch (outcome) {
    case 'TRANSFERRED_TO_FLOW':
      return {
        backgroundColor: 'rgb(248, 250, 252)',
        color: 'rgb(30, 41, 59)',
        borderColor: 'rgb(148, 163, 184)'
      };
    case 'TRANSFERRED_TO_AGENT':
      return {
        backgroundColor: 'rgb(219, 234, 254)',
        color: 'rgb(30, 64, 175)',
        borderColor: 'rgb(147, 197, 253)'
      };
    case 'DROPPED':
    case 'DISCONNECTED_PARTICIPANT':
      return {
        backgroundColor: 'rgb(254, 226, 226)',
        color: 'rgb(153, 27, 27)',
        borderColor: 'rgb(252, 165, 165)'
      };
    case 'ENDED_FLOW_EXECUTION':
      return {
        backgroundColor: 'rgb(220, 252, 231)',
        color: 'rgb(22, 101, 52)',
        borderColor: 'rgb(134, 239, 172)'
      };
    default:
      return {
        backgroundColor: 'rgb(243, 244, 246)',
        color: 'rgb(31, 41, 55)',
        borderColor: 'rgb(209, 213, 219)'
      };
  }
};

export const OutcomeEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data
}: EdgeProps) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  const outcome = data?.outcome as string;

  if (!outcome || outcome === 'ENDED_FLOW_EXECUTION') {
    return <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />;
  }

  const outcomeStyle = getOutcomeColor(outcome);

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 11,
            pointerEvents: 'all'
          }}
          className='nodrag nopan'
        >
          <div
            className='px-1 py-0.5 rounded-md border font-medium shadow-sm whitespace-nowrap'
            style={{
              backgroundColor: outcomeStyle.backgroundColor,
              color: outcomeStyle.color,
              borderColor: outcomeStyle.borderColor
            }}
          >
            {formatOutcome(outcome)}
          </div>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
